module.exports = __webpack_public_path__ + "static/media/ginny-default.e7c13d2d.webp";